var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({on:{"click":_vm.handleClick}},'button',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.displayText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }